import React from 'react';
import Watertank from './component/waterTank/index';

function App() {
  return (
      <div>
        <Watertank/>
      </div>
  );
}

export default App;
